import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'

interface Props {
  employeeId: string
  value: string | null
  onChange: (value: string | null) => void
}

const ReassignManagerSelect = ({ employeeId, value, onChange }: Props) => {
  const handleEmployeeSelect = (selectedEmpId: string | undefined) => {
    onChange(selectedEmpId ?? null)
  }

  return (
    <EmployeeSelectorV2
      forcedFilters={{ excludeIds: [employeeId] }}
      value={value ?? undefined}
      onChange={handleEmployeeSelect}
      label={i18n.t(
        'contract_versions.header.pause_resume.pause_modal.reassign_responsibilities_label'
      )}
      options={{
        hideSearchIcon: true,
      }}
    />
  )
}

export default ReassignManagerSelect
